import { apiSlice } from "../../../api/ApiService";

const getAdminMasterDataApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAdminMasterDataApi: builder.query({
      query: ({ accessToken }: { accessToken: string | null }) => ({
        url: `/api/v1/Administration/masterdata`,
        method: "GET",
        headers: accessToken && { Authorization: `Bearer ${accessToken}` },
      }),
    }),
    getAdminRoleDescription: builder.query({
      query: ({ accessToken }: { accessToken: string | null }) => ({
        url: `/api/v1/Administration/user-role-access`,
        method: "GET",
        headers: accessToken && { Authorization: `Bearer ${accessToken}` },
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetAdminMasterDataApiQuery,
  useGetAdminRoleDescriptionQuery,
} = getAdminMasterDataApi;
export default getAdminMasterDataApi;
